<script src="../../../../../../main.js"></script>
<template>
    <div id="dataCenter">
        <div class="container">
            <!--<vHeader></vHeader>-->
            <div class="containData">
                <div class="lefttData" @click="goBack(1)">
                    <div class="imgTitle"></div>
                    <div class="leftImg"></div>
                </div>
                <div class="centerData">
                    <div class="centerTitle" @click="goBack(0)"></div>
                </div>
                <div class="rightData" @click="goBack(2)">
                    <div class="imgTitle"></div>
                    <div class="rightImg"></div>
                </div>
            </div>
        </div>
        <router-view></router-view>
    </div>

</template>
<script>
    // import vHeader from '@/components/header/index'
    export default {
        name: "main-data-center",
        components: {
            // vHeader,
        },
        methods: {
            goBack(index) {
                if (index === 0) {
                    this.goMain('/modeling')
                } else if (index === 1) {
                    this.goMain('/flight')
                } else if (index === 2) {
                    this.goMain('/labReport')
                } else {
                    this.goMain('/main')
                }
            }
        }
    }
</script>
<style lang="less" scoped>
    #dataCenter{
        .container {
            width: 100%;
            height: 100vh;
            background: url("../../../../static/img/back.fbd1c77.png") no-repeat;
            background-size: cover;
            .containData{
                height: 57vh;
                width: 100%;
                padding-top: 43vh;
                display: flex;
                .rightData{
                    width: 33.33%;
                    position: relative;
                    .imgTitle{
                        background: url("../../../../static/img/labReport.png") no-repeat;
                        background-size: 100%;
                        height: 9.6vh;
                        width: 43%;
                        position: absolute;
                        right: 40%;
                        /*top: 30vh;*/
                    }
                    .rightImg{
                        background: url("../../../../static/img/right1.png") no-repeat;
                        background-size: 100%;
                        height: 37vh;
                        width: 24%;
                        position: absolute;
                        right: 50%;
                        bottom: 6vh;
                    }
                }
                .rightData:hover{
                    width: 33.33%;
                    position: relative;
                    .imgTitle{
                        background: url("../../../../static/img/lab2.png") no-repeat;
                        background-size: 100%;
                        height: 16vh;
                        width: 52%;
                        position: absolute;
                        right: 35%;
                        top: -4vh;
                        /*top: 26vh;*/
                    }
                    .rightImg{
                        background: url("../../../../static/img/right2.png") no-repeat;
                        background-size: 100%;
                        height: 46vh;
                        width: 37%;
                        position: absolute;
                        right: 42%;
                        bottom: 1vh;
                    }
                }
                .centerData{
                    width: 33.33%;
                    position: relative;
                    .centerTitle{
                        background: url("../../../../static/img/counter.png") no-repeat;
                        background-size: 100%;
                        height: 9.6vh;
                        width: 43%;
                        position: absolute;
                        top: -17vh;
                        right: 20%;
                    }
                    .centerTitle:hover{
                        background: url("../../../../static/img/counters.png") no-repeat;
                        background-size: 100%;
                        height: 18vh;
                        width: 53%;
                        position: absolute;
                        top: -21vh;
                        right: 14%;
                    }
                }
                .lefttData{
                    width: 33.33%;
                    position: relative;
                    .imgTitle{
                        background: url("../../../../static/img/results.png") no-repeat;
                        background-size: 100%;
                        height: 9.6vh;
                        width: 43%;
                        position: absolute;
                        /*top: 30vh;*/
                        right: 1%;
                    }
                    .leftImg{
                        background: url("../../../../static/img/left1.png") no-repeat;
                        background-size: 100%;
                        height: 38vh;
                        width: 28%;
                        position: absolute;
                        right: 10%;
                        bottom: 7vh;
                    }
                }
                .lefttData:hover{
                    width: 33.33%;
                    position: relative;
                    .imgTitle{
                        background: url("../../../../static/img/results2.png") no-repeat;
                        background-size: 100%;
                        height: 17vh;
                        width: 52%;
                        position: absolute;
                        right: -3%;
                        top: -4vh;
                    }
                    .leftImg{
                        background: url("../../../../static/img/left02.png") no-repeat;
                        background-size: 100%;
                        height: 47vh;
                        width: 42%;
                        position: absolute;
                        right: 3%;
                        bottom: 2vh;
                    }
                }
            }
        }
    }

</style>



// WEBPACK FOOTER //
// src/views/main/dataCenter/main-dataCenter.vue